module.exports = __webpack_public_path__ + "img/success_yellow@2x.31ca48a8.png";